module.exports = __webpack_public_path__ + "static/media/cartoes_cinza.db719a66.svg";